import { attach, createEffect, StoreValue } from "effector";
import { buy } from "sdk/auction-house";
import { $connection } from "state/connection";
import { $store } from "state/store";
import { $wallet } from "state/wallet";
import { IInstantSale } from "./types";

interface IBuyProps {
  sale: IInstantSale;
}

export const purchaseAhFx = attach({
  effect: createEffect(
    async ({
      sale,
      wallet,
      connection,
      store,
    }: IBuyProps & {
      connection: StoreValue<typeof $connection>;
      wallet: StoreValue<typeof $wallet>;
      store: StoreValue<typeof $store>;
    }) => {
      if (!store) {
        throw new Error("Empty store");
      }

      if (!wallet) {
        throw new Error("Empty wallet");
      }
      return await buy({
        connection,
        wallet,
        sale,
        auctionHouse: store.storeAhId,
      });
    }
  ),
  source: {
    wallet: $wallet,
    connection: $connection,
    store: $store,
  },
  mapParams: (params: IBuyProps, sources) => ({ ...params, ...sources }),
});
